import React, {useRef, useState, useEffect, useImperativeHandle, forwardRef} from 'react'
import WXWAccount from "./wxwAccount";
import {Button} from "antd";

/**
 * 企业微信账号列表
 * @param collapsed true:收起，false：展开
 * @param accountChange 选中账号的时候回调，默认选中也需要进行回调
 * @author Yaochao
 * @date 2022/2/16 15:58
 * @description
 */
const WxwAccountList = forwardRef(({
                                       setNeed: setNeed,
                                       collapsed: collapsed,
                                       onChange: accountChange,
                                       aFold: aFold,
                                       unfoldLinkMan: unfoldLinkMan,
                                       wxid: wxid
                                   }, ref) => {
    // const [msgNum, setMsgNum] = useState(null)
    const wxwAccountRef = useRef()

    //获取选中的微信账号列表
    function getWxAccount(list) {
        accountChange(list)
    }

    //新消息来改变未读数
    function getMsgNum(msg) {
        wxwAccountRef.current.getMsgNum(msg.data)
        // setMsgNum(msg.data)
    }

    useImperativeHandle(ref, () => ({
        getMsgNum: getMsgNum,
        getData: wxwAccountRef.current.getData,
        queryLinkMan: wxwAccountRef.current.queryLinkMan,
        isValidAccountFromServer: wxwAccountRef.current.isValidAccountFromServer,
        heartBeatChange: wxwAccountRef.current.heartBeatChange,
        popUp: wxwAccountRef.current.popUp,
        openChatMessageChange: wxwAccountRef.current.openChatMessageChange,
        closeChatMessageChange: wxwAccountRef.current.closeChatMessageChange
    }));
    return (
        <>
            <WXWAccount ref={wxwAccountRef} wxid={wxid} collapsed={collapsed}
                        setNeed={setNeed}
                        getWxAccount={getWxAccount} aFold={aFold} unfoldLinkMan={unfoldLinkMan}/>
        </>
    )
});

export default WxwAccountList